/**
 * ODIN API
 * This is the OpenAPI documentation for the ODIN API. It provides details about the available endpoints, request and response formats, and authentication mechanisms.   <br /> <br /> The API is organized into different areas, each representing a specific domain of functionality within the ODIN system:  <br /> <br /><strong>FRONTEND API</strong> documentation (<a href=\"/api/doc/frontend/v1\">v1</a>, <a href=\"/api/doc/frontend/v2\">v2</a>)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PaymentGatewayEnvironment {
    production = 'production',
    stage = 'stage'
}

